import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { lionSelectors, LionTranslate } from '@rosetta/react-lion';
import { authSelectors, LOGIN_STATUS } from '@rosetta/react-auth';
import { appActions, appSelectors } from '../reducer/app-reducer';
import { getAvailableInterfaceLanguages } from '../../app/services/language-helpers';
import { RSDropdown } from '@rosetta/rs-dropdown';
import { menuStyle } from '../../../styles/InterfaceLanguageMenuStyle';
import styled from '@emotion/styled';
import { withWindowDimensions } from '@rosetta/react-common-ui';

import { appFooterBackground, footerTextColor } from '../../../styles/colors';
import { footerHeight } from '../../../styles/constants';
import { ltrDir } from '../constants';
import { isMobile as isMobileDetected } from 'react-device-detect';

let isRtl = false;

const AppFooterDiv = styled.div((props) => {
  let style = {
    backgroundColor: appFooterBackground,
    bottom: '0',
    left: '0',
    right: '0',
    fontSize: '11px',
    zIndex: '9'
  };

  if (!props.isMobile) {
    style.height = footerHeight;
    style.position = 'absolute';
  } else {
    style.textAlign = 'center';
  }

  return style;
});

const Copyright = styled.div((props) => {
  let style = {
    color: footerTextColor,
    direction: ltrDir,
    fontSize: '9px',
    fontWeight: 'normal',
    left: !props.isMobile ? '19px' : 'auto',
    paddingBottom: !props.isMobile ? '0px' : '17px',
    position: !props.isMobile ? 'absolute' : 'relative',
    top: !props.isMobile ? '33px' : 'auto'
  };

  if (isRtl) {
    style.left = 'auto';
    style.right = '20px';
  }
  return style;
});

const LegalLinks = styled.div((props) => {
  let style = {};

  if (!props.isMobile) {
    style.position = 'absolute';
    style.right = '20px';
    style.left = '20px';
    style.top = '14px';
  }
  if (isRtl) {
    style.left = 'auto';
    style.right = '20px';
  } else {
    style.left = '20px';
    style.right = 'auto';
  }

  return style;
});

const FooterLinkSpan = styled.span((props) => {
  let style = {
    display: props.isMobile ? 'block' : 'inline-block'
  };
  if (props.isMobile) {
    style.marginBottom = '17px';
  }
  if (isRtl) {
    style.paddingRight = '0px';
    style.paddingLeft = '20px';
  } else {
    style.paddingRight = '20px';
    style.paddingLeft = '0px';
  }

  if (props.isMobile) {
    style.marginBottom = '17px';
    style.padding = '0';
  }
  return style;
});

const FooterLink = styled.a((props) => {
  let style = {
    textDecoration: 'none',
    cursor: 'pointer',
    outline: '0',
    fontWeight: 'bold',
    color: footerTextColor,
    backgroundColor: 'transparent',
    ':hover': {
      color: footerTextColor,
      backgroundColor: 'transparent',
      textDecoration: 'underline'
    }
  };

  return style;
});

const LocaleSelectorContainer = styled.div((props) => {
  let style = {
    height: footerHeight,
    width: 140
  };
  if (isRtl) {
    style.float = props.isMobile ? 'none' : 'left';
    style.marginLeft = props.isMobile ? 'auto' : '16px';
    style.marginRight = props.isMobile ? 'auto' : '0px';
  } else {
    style.float = props.isMobile ? 'none' : 'right';
    style.marginLeft = props.isMobile ? 'auto' : '0px';
    style.marginRight = props.isMobile ? 'auto' : '16px';
    style.textAlign = props.isMobile ? 'center' : 'right';
  }

  return style;
});

//*********************************************
export class AppFooter extends PureComponent {
  copyrightStr = null;
  getCopyright = () => {
    if (!this.copyrightStr) {
      const baseString = this.props.lionTranslateString('email_footer_text1_copyright');
      const today = new Date();
      const year = today.getFullYear().toString();
      this.copyrightStr = baseString.replace('{{year}}', year);
    }
    return this.copyrightStr;
  };

  // DEV ONLY RTL - for working with RTL in non-SEU
  //  you have to copy the lion/seu/language-ar-SA.json file out to lion
  devThing = () => {
    // const uiLang = this.props.currentLocale;
    // if (uiLang === 'en-US') {
    //   this.props.setInterfaceLanguage('ar-SA');
    // } else {
    //   this.props.setInterfaceLanguage('en-US');
    // }
  };

  handleInterfaceLanguageSelected = (languageObj) => {
    this.props.setInterfaceLanguage(languageObj.value);
  };

  render = () => {
    if (!this.props.lionLoaded) {
      return null;
    }

    isRtl = this.props.isInterfaceRtl;
    const isMobile = isMobileDetected;

    let copyrightDiv = <Copyright isMobile={isMobile}>{this.getCopyright()}</Copyright>;

    let links = null;
    if (this.props.userIsLoggedIn) {
      links = (
        <LegalLinks isMobile={isMobile}>
          <FooterLinkSpan isMobile={isMobile}>
            <FooterLink href="http://www.rosettastone.com/termsonline" target="_blank" tabIndex={-1}>
              <LionTranslate lionkey="_terms_of_service" />
            </FooterLink>
          </FooterLinkSpan>
          <FooterLinkSpan isMobile={isMobile}>
            <FooterLink
              href="http://www.rosettastone.com/interactiveproductprivacy"
              target="_blank"
              tabIndex={-1}
              isMobile={isMobile}
            >
              <LionTranslate lionkey="_privacy_policy" />
            </FooterLink>
          </FooterLinkSpan>
          <FooterLinkSpan isMobile={isMobile}>
            <FooterLink href="http://www.rosettastone.com/agreements" target="_blank" tabIndex={-1} isMobile={isMobile}>
              <LionTranslate lionkey="launchpad_footer_agreements" />
            </FooterLink>
          </FooterLinkSpan>
          <FooterLinkSpan isMobile={isMobile}>
            <FooterLink
              href="http://support.rosettastone.com/SupportINSProductTemplate"
              target="_blank"
              tabIndex={-1}
              isMobile={isMobile}
            >
              <LionTranslate lionkey="launchpad_footer_support" />
            </FooterLink>
          </FooterLinkSpan>
        </LegalLinks>
      );
    } else {
      links = (
        <LegalLinks isMobile={isMobile}>
          <FooterLinkSpan isMobile={isMobile}>
            <FooterLink href="http://www.rosettastone.com/privacy" target="_blank" tabIndex={-1}>
              <LionTranslate lionkey="launchpad_footer_privacypolicy" />
            </FooterLink>
          </FooterLinkSpan>
          <FooterLinkSpan isMobile={isMobile}>
            <FooterLink href="http://www.rosettastone.com/terms" target="_blank" tabIndex={-1}>
              <LionTranslate lionkey="launchpad_footer_terms" />
            </FooterLink>
          </FooterLinkSpan>
          <FooterLinkSpan isMobile={isMobile}>
            <FooterLink href="http://www.rosettastone.com/agreements" target="_blank" tabIndex={-1}>
              <LionTranslate lionkey="launchpad_footer_agreements" />
            </FooterLink>
          </FooterLinkSpan>
          <FooterLinkSpan isMobile={isMobile}>
            <FooterLink
              href="http://support.rosettastone.com/SupportINSProductTemplate"
              target="_blank"
              tabIndex={-1}
              isMobile={isMobile}
            >
              <LionTranslate lionkey="launchpad_footer_support" />
            </FooterLink>
          </FooterLinkSpan>
        </LegalLinks>
      );
    }

    return (
      <AppFooterDiv onClick={this.devThing} isMobile={isMobile}>
        <LocaleSelectorContainer isMobile={isMobile}>
          <RSDropdown
            dataQa="InterfaceLanguageMenu"
            buttonText=""
            itemsList={getAvailableInterfaceLanguages()}
            itemDisplayProperty="nativeName"
            itemKeyProperty="value"
            onSelectionHandler={this.handleInterfaceLanguageSelected}
            selectedKey={this.props.currentLocale}
            isRtl={isRtl}
            menuStyle={menuStyle}
          />
        </LocaleSelectorContainer>
        {links}
        {copyrightDiv}
      </AppFooterDiv>
    );
  };
}

AppFooter.propTypes = {};

const mapStateToProps = (state, ownprops) => ({
  currentLocale: lionSelectors.getLionLanguage(state),
  isInterfaceRtl: appSelectors.isInterfaceRtl(state),
  lionLoaded: lionSelectors.getLionAppResourcesLoaded(state),
  lionTranslateString: (key, placeholders, values) => {
    return lionSelectors.getLionTranslatedString(state, key, placeholders, values);
  },
  userIsLoggedIn: authSelectors.loginStatus(state) === LOGIN_STATUS.LOGGED_IN
});

const wrappedActions = { setInterfaceLanguage: appActions.setInterfaceLanguage };
export const AppFooterContainer = connect(
  mapStateToProps,
  wrappedActions
)(withWindowDimensions(AppFooter));



// WEBPACK FOOTER //
// ./src/modules/app/components/AppFooter.jsx